const mem = {};
const wrap = (kind) => ({
  get(k) { try { return window[kind].getItem(k); } catch { return mem[`${kind}:${k}`] ?? null; } },
  set(k, v) { try { window[kind].setItem(k, v); } catch { mem[`${kind}:${k}`] = v; } },
  remove(k) { try { window[kind].removeItem(k); } catch { delete mem[`${kind}:${k}`]; } },
});
export const local = wrap("localStorage");
export const session = wrap("sessionStorage");
